export { default } from './BadgesPlaceholder';
